/* ==========================================================================
   Satjeevan — Collection Product Grid JS (collection-product-grid.js)

   One job: auto-submit the sort <select> on change. Everything else on
   this section (tag filter pills, pagination) is plain native <a> links —
   real navigation, real Shopify collection filtering/sorting/pagination,
   no JS required for those to work.

   Variant-chip switching + Add to Cart on each card are handled entirely
   by assets/product-recommended-carousel.js (grid mode) and Horizon's
   native <product-form-component>/<add-to-cart-component> — this file
   never touches either.
   ========================================================================== */

(function () {
  'use strict';

  var INIT_ATTR = 'data-sj-init';

  function initSort(select) {
    if (select.hasAttribute(INIT_ATTR)) return;
    select.setAttribute(INIT_ATTR, '1');
    select.addEventListener('change', function () {
      if (select.form) select.form.submit();
    });
  }

  function init() {
    document.querySelectorAll('[data-collgrid-sort]').forEach(initSort);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Theme Editor live-reload support
  document.addEventListener('shopify:section:load', init);
})();
